import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SessionProvider } from "./auth/session.js";
import { initTheme } from "./components.js";
import { App } from "./App.js";
import "./styles.css";

initTheme(); // dark-default per the locked design

const container = document.getElementById("root");
if (!container) throw new Error("SeneSight: missing #root element");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
